import { Record } from 'immutable';

const AddressRecord = Record({
  addressLine1: null,
  addressLine2: null,
  addressLine3: null,
  addressLine4: null,
  city: null,
  county: null,
  postalCode: null,
  region: null,
  street: null,
});

export default class Address extends AddressRecord {
  static deserialize(jsonObject = {}) {
    return new Address(jsonObject);
  }
}
